import React from "react";
import { FiX } from "react-icons/fi";
import PageModal from "../../Dashboard/Components/PageModal";

function PhotoModal({ photoUrl, onClose }) {
  if (!photoUrl) return null;

  return (
    <PageModal>
      <div className="bg-white p-1 md:p-2 rounded-xl max-w-4xl w-full relative shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-white bg-black/70 hover:bg-black/90 rounded-full p-1.5 z-20 transition-colors shadow-md"
        >
          <FiX size={18} />
        </button>
        <div className="overflow-hidden rounded-lg">
          <img
            src={photoUrl}
            alt="Announcement"
            className="max-w-full max-h-[80vh] object-contain"
          />
        </div>
      </div>
    </PageModal>
  );
}

export default PhotoModal;
